import {ChangeDetectorRef, Component} from '@angular/core';
import {FirmwareService} from "../../services/firmware.service";
import {AbstractProdGrid, IProdGrid, ProdGridColumnTransforms, ProdGridColumnType} from 'prod-grid';
import {DipColumn} from "../../dip/dip-column";
import {FirmwareFormComponent} from "./form/firmware-form/firmware-form.component";
import {OrganizationService} from "../../services/organization.service";
import {FirmwareTypeService} from "../../services/firmware-type.service";
import {DeviceTypeService} from "../../services/device-type.service";
import {Role} from "../../dip/role";
import {RoleService} from "../../services/role.service";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-firmware',
  templateUrl: './firmware.component.html'
})
export class FirmwareComponent extends AbstractProdGrid implements IProdGrid {
  prodGridTitle: string = this.translate.instant('firmware.grid_title');
  isAddButtonDisabled: boolean = !this.roleService.hasRole([Role.ROLE_SYS]);
  isRemoveButtonDisabled: boolean = !this.roleService.hasRole([Role.ROLE_SYS]);
  override prodGridForm = {component: FirmwareFormComponent};
  prodGridColumns: DipColumn[] = [
    DipColumn.get({
      property: 'deviceType.name',
      type: ProdGridColumnType.SELECT_COMPONENT,
      selectParameters: {
        selectDataService: DeviceTypeService,
        isMulti: true,
        isNarrowDown: true,
        isComplete: true
      },
      isEnum: true
    }),
    DipColumn.get({property: 'header', type: ProdGridColumnType.STRING}),
    DipColumn.get({property: 'version', type: ProdGridColumnType.STRING}),
    DipColumn.get({
      property: 'type.name',
      type: ProdGridColumnType.SELECT_COMPONENT,
      selectParameters: {
        selectDataService: FirmwareTypeService,
        isMulti: true,
        isComplete: true,
        isNarrowDown: true
      },
      isEnum: true
    }),
    DipColumn.get({property: 'id', type: ProdGridColumnType.ID}),
    DipColumn.get({
      property: 'organizations',
      type: ProdGridColumnType.SELECT_COMPONENT,
      transform: {
        transform: ProdGridColumnTransforms.ARRAY_JOIN,
        option: 'name'
      },
      sortable: false,
      selectParameters: {
        selectDataService: OrganizationService,
        isComplete: true,
        isNarrowDown: true,
        isMulti: true
      }
    }),
    DipColumn.get({
      property: 'createdAt',
      type: ProdGridColumnType.DATE,
      transform: {
        transform: ProdGridColumnTransforms.DATETIME
      }
    })
  ];

  constructor(protected override changeDetectorRef: ChangeDetectorRef,
              override prodGridDataService: FirmwareService,
              private roleService: RoleService,
              private translate: TranslateService) {
    super(changeDetectorRef);
  }
}
